import React from 'react';

const Section8 = () => {
    return (
        <div className='text-center py-10 mb-10'>
            <h2 className='text-3xl font-bold text-primary-600'>Not what you were looking for?</h2>
            <button className='text-2xl font-bold text-white bg-primary-500 hover:bg-primary-600 px-6 py-2 rounded-full my-5'>VIEW OTHER PRODUCTS</button>
            <p className='text-lg text-gray-600'>or call us 888.321.7828</p>
        </div>
    );
};

export default Section8;